<div class="gh" (click)="closed.emit()">
    <div class="gh-frame" role="dialog" aria-modal="true" aria-labelledby="gh-title" (click)="$event.stopPropagation()">
        <div class="gh-bar">
            <b id="gh-title">Gallery shortcuts</b>
            <button type="button" class="gh-close" (click)="closed.emit()" matTooltip="Close (Esc)" aria-label="Close"><img src="../../assets/icons/x.svg" alt="" /></button>
        </div>

        <div class="gh-body">
            <section class="gh-sec" [class.is-here]="from === 'gallery'">
                <h3>In the gallery</h3>
                <dl>
                    <dt><span class="gh-act">Click</span></dt><dd>Open an image, clip or PDF in the viewer</dd>
                    <dt><span class="gh-act">Tick</span> or <span class="gh-act">drag across</span></dt><dd>Select up to 4 clips to play together</dd>
                    <dt><span class="gh-act">Play in a grid</span></dt><dd>Play the selected clips side by side</dd>
                    <dt *ngIf="cardio"><span class="gh-act">Gallery view</span></dt><dd *ngIf="cardio">By Type, or Timeline in recording order</dd>
                    <dt><kbd>?</kbd></dt><dd>Open these shortcuts</dd>
                </dl>
            </section>

            <section class="gh-sec" [class.is-here]="from === 'viewer'">
                <h3>In the viewer</h3>
                <dl>
                    <dt><kbd>&larr;</kbd> <kbd>&rarr;</kbd></dt><dd>Previous or next, also while a clip plays</dd>
                    <dt><span class="gh-act">Click a thumbnail</span></dt><dd>Jump straight to it</dd>
                    <dt><kbd>F</kbd></dt><dd>Full screen</dd>
                    <dt><kbd>Esc</kbd></dt><dd>Leave full screen, then close</dd>
                    <dt *ngIf="deletable"><span class="gh-act">Delete</span></dt><dd *ngIf="deletable">Delete what is on screen. It asks first</dd>
                    <dt><span class="gh-act">PDF</span></dt><dd>Print, zoom and search with the browser's own buttons, or Open In Different Tab</dd>
                </dl>
            </section>

            <section class="gh-sec" [class.is-here]="from === 'grid'">
                <h3>In the grid</h3>
                <dl>
                    <dt><kbd>Space</kbd></dt><dd>Pause or play every clip</dd>
                    <dt><span class="gh-act">Pause button on a clip</span></dt><dd>Pause just that clip</dd>
                    <dt><span class="gh-act">Click a clip</span></dt><dd>Open it alone. <kbd>&larr;</kbd> <kbd>&rarr;</kbd> step through the grid's clips, <kbd>Esc</kbd> returns to the grid</dd>
                    <dt><span class="gh-act">Drag a clip</span></dt><dd>Move it to another place. Onto another clip, the two swap</dd>
                    <dt><span class="gh-act">Clips strip</span></dt><dd>Add a clip or take one out, without closing the grid</dd>
                    <dt><span class="gh-act">&times; on a clip</span></dt><dd>Take it out of the grid</dd>
                    <dt><kbd>F</kbd> &nbsp; <kbd>Esc</kbd></dt><dd>Full screen, close</dd>
                </dl>
            </section>
        </div>
    </div>
</div>
